import { takeEvery, call, put, select } from 'redux-saga/effects';
import { t } from 'utils/translates';
import {
  initState,
  sendRequest,
  selectFormBody,
  requestInProcess,
  requestFinished,
  setErrors,
  clearAllErrors
} from '../../../../common/reducers/forms/transferFundsForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserFlowFundsService from '../../../../services/UserFlowFundsService';
import { sendGetAuthAccountDataRequest } from '../../../../../users/common/reducers/states/authAccount';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';

function* transferFundsFormSaga(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearAllErrors(reducerName));
    const result = yield call(
      timeoutCall,
      UserFlowFundsService.transferFunds,
      formBody
    );
    if (result) {
      if (result.status === 422) {
        yield put(setErrors(reducerName, result.data));
      } else if (result.status === 200) {
        yield put(initState(reducerName));
        yield put(sendGetAuthAccountDataRequest());
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: t('Перевод с основного счета выполнен')
          })
        );
      }
      yield put(
        requestFinished(reducerName, result.status, result.status === 200)
      );
    }
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function createSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, transferFundsFormSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/reducers/static/forms/sagas/transferFundsFormSaga.js